export interface UserInfo {
  _id: string;
  name: string;
  email: string;
}

export interface Transaction {
  _id: string;
  type: TransactionType;
  status: TransactionStatus;
  amount: number;
  note?: string;
  comment?: string;
  createdAt: string;
  updatedAt?: string;
  user: UserInfo;
  txId?: string;
  coin?: string;
  adjustedAmount?: number;
  totalInCrypto?: number;
  amountInNGN?: number;
  amountInUsd?: number;
  withdrawalType?: string;
  // Which balance paid: account | reward | referral (withdrawals / payouts)
  source?: string;
  redbillerStatus?: string;
  refundedAt?: string;
  // NIBSS session id of a naira payout (PalmPay/Nomba); absent for Breet/manual.
  providerSessionId?: string;
  sourceCollection?: string;
  reason?: string;
}

export enum TransactionType {
  GIFTCARD_SELL = 'GIFTCARD_SELL',
  CRYPTO_SELL = 'CRYPTO_SELL',
  WALLET_CRYPTO_SELL = 'WALLET_CRYPTO_SELL',
  QUICK_CRYPTO_SELL = 'QUICK_CRYPTO_SELL',
  CRYPTO_PAYOUT = 'CRYPTO_PAYOUT',
  WITHDRAW = 'WITHDRAW',
  BANK_DEPOSIT = 'BANK_DEPOSIT',
  LEADERSHIP_BONUS = 'LEADERSHIP_BONUS',
  EBILLS = 'EBILLS',
  STREAK_BONUS = 'STREAK_BONUS',
  // Ghana mobile-money payout (naira debited, GH₵ sent)
  MOMO_WITHDRAW = 'MOMO_WITHDRAW',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  SUSPENDED = 'SUSPENDED',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  TIMEOUT = 'TIMEOUT',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PROCESSED = 'PROCESSED',
  REVERTED = 'REVERTED',
  CREDITED = 'CREDITED',
  FAILED = 'FAILED',
}

export interface TransactionFilterInput {
  types?: TransactionType[];
  statuses?: TransactionStatus[];
  startDate?: string;
  endDate?: string;
  coin?: string;
  minAmount?: number;
  maxAmount?: number;
  search?: string;
}

export interface PaginationInput {
  page: number;
  limit: number;
}

export interface PaginatedTransactions {
  data: Transaction[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface GetUserTransactionsData {
  getUserTransactions: PaginatedTransactions;
}

export interface GetAllUserTransactionsData {
  getAllUserTransactions: Transaction[];
} 